"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOption = void 0;
const vue_1 = require("vue");
const Button_1 = require("../components/common/Button");
const TranslateMixin_1 = require("./TranslateMixin");
exports.SelectOption = vue_1.default.component('select-option', {
    props: {
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    components: {
        'Button': Button_1.Button,
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    data: function () {
        return {};
    },
    methods: {
        saveData: function () {
            this.onsave([['1']]);
        },
    },
    template: `<div class="wf-component wf-component--select-option">
        <div v-if="showtitle === true" class="wf-component-title">{{ $t(playerinput.title) }}</div>
        <Button v-if="showsave === true" size="big" :onClick="saveData" :title="$t(playerinput.buttonLabel)" />
    </div>`,
});
//# sourceMappingURL=SelectOption.js.map